import { Loader, Tabs, Text } from "@mantine/core";
import CustomizationTab from "./tabs/CustomizationTab";
import HomeScreenTab from "./tabs/HomeScreenTab";
import {
  IconBrush,
  IconHome,
  IconSettings,
  IconSettingsCog,
} from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../../services/context";
import { getCurrentWorkspace } from "../../../services/userConfig";
import { useGetEvent } from "../../../api/event";
import { useGetMobileMetadata } from "../../../api/systemSettings";
import General from "./tabs/GeneralTab";
import FeatureTab from "./tabs/FeatureTab";

const CustomTabsEvent = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);

  const isSysAdmin = user?.role === "sysAdmin";
  const isAdmin = user?.role === "sysAdmin" || user?.role === "wsAdmin";

  const { data, isPending, isError, error } = useGetEvent(
    currentWorkspace?.eventId
  );

  // The home screen arrangement and the phone preview only reach attendees on
  // the new app, so they stay hidden until that app is what the stores ship.
  const { data: mobileMetadata } = useGetMobileMetadata();
  const useNewMobileApp = mobileMetadata?.useNewMobileApp === true;

  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };
  if (isPending) {
    return <Loader mt={10} />;
  }
  if (isError) {
    return <Text c="red">{error.message}</Text>;
  }
  const requestedTab = searchParams.get("tab") || "general";
  // A link to a tab that is gated off lands on the settings tab rather than on
  // an empty panel.
  const tabValue =
    requestedTab === "homeScreen" && !useNewMobileApp
      ? "general"
      : requestedTab;
  return (
    <Tabs
      keepMounted={true}
      variant="outline"
      value={tabValue}
      onChange={(value) => handleTabChange(value)}
    >
      <Tabs.List>
        <Tabs.Tab value="general" leftSection={<IconSettings size={12} />}>
          Settings
        </Tabs.Tab>
        <Tabs.Tab value="customization" leftSection={<IconBrush size={12} />}>
          Customization
        </Tabs.Tab>
        {useNewMobileApp && (
          <Tabs.Tab value="homeScreen" leftSection={<IconHome size={12} />}>
            Home Screen
          </Tabs.Tab>
        )}
        {isAdmin && (
          <Tabs.Tab
            value="features"
            leftSection={<IconSettingsCog size={12} />}
          >
            Features
          </Tabs.Tab>
        )}
      </Tabs.List>

      <Tabs.Panel value="general">
        <General data={data} isSysAdmin={isSysAdmin} />
      </Tabs.Panel>
      <Tabs.Panel value="customization">
        <CustomizationTab data={data} showPreview={useNewMobileApp} />
      </Tabs.Panel>
      {useNewMobileApp && (
        <Tabs.Panel value="homeScreen">
          <HomeScreenTab key={data.id} data={data} />
        </Tabs.Panel>
      )}
      {isAdmin && (
        <Tabs.Panel value="features">
          <FeatureTab event={data} />
        </Tabs.Panel>
      )}
    </Tabs>
  );
};

export default CustomTabsEvent;
